import { EdisonWallBoxFormData } from 'src/Libs/installation-statement/models/edisonWallBox'

export const DEFAULT_EDISON_WALLBOX_DATA: EdisonWallBoxFormData = {
  serialNumbers: {
    connect: '',
    power: '',
  },
  vehicleInformation: {
    manufacturer: '',
    model: '',
    batteryCapacity: 0,
    softwareVersion: '',
  },
  functionalityTests: {
    fullyInstalled: false,
    configured: false,
    scenarioOneTested: false,
    scenarioTwoTested: false,
    customerBriefed: false,
    biDirectionalDCChargingConfiguration: {
      positionedAtChargingPoint: false,
      chargingLocationDefined: false,
      functionActivated: false,
    },
  },
}
